export default __webpack_public_path__ + "static/media/panel.9e96880c.svg";